import {useQuery} from 'react-query'

import {DiscountCouponFragment} from '@/utils/graphqlSdk'

import {DiscountCouponEntity} from '../constants'
import {routeTo} from '../router'

export const useVerifyDiscountCoupon = (
  discountCouponId: string | null | undefined,
  entityType: DiscountCouponEntity,
) => {
  return useQuery<DiscountCouponFragment>(
    ['verifyDiscountCoupon', discountCouponId],
    async () => {
      try {
        const response = await fetch(routeTo.api.discountCoupon.verify(discountCouponId!), {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({
            entityType,
          }),
        })

        if (response?.ok) {
          const data = await response.json()
          return data?.coupon ?? null
        }
        return null
      } catch (e) {
        throw new Error(e)
      }
    },
    {
      enabled: Boolean(discountCouponId),
    },
  )
}
